import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { StationsMap } from "./stationsMap";
import { Faq } from "./faq";
import { LinkLists } from "./linkLists";
import { StandardContent } from "./standardContent";
import { Tabs } from "./tabs";
import { TextImage } from "./textImage";
export var renderContentModule = function(module, translations) {
    switch(module.moduleType){
        case "faqs":
            return /*#__PURE__*/ _jsx(Faq, _object_spread_props(_object_spread({}, module), {
                translations: translations.faq
            }));
        case "linkListGroup":
            return /*#__PURE__*/ _jsx(LinkLists, _object_spread_props(_object_spread({}, module), {
                translations: translations.linklists
            }));
        case "standardContent":
            return /*#__PURE__*/ _jsx(StandardContent, _object_spread_props(_object_spread({}, module), {
                translations: translations.standardContent
            }));
        case "stationsMap":
            return /*#__PURE__*/ _jsx(StationsMap, _object_spread({}, module));
        case "tabs":
            return /*#__PURE__*/ _jsx(Tabs, _object_spread_props(_object_spread({}, module), {
                translations: translations.tabs
            }));
        case "textImage":
        default:
            return /*#__PURE__*/ _jsx(TextImage, _object_spread({}, module));
    }
};
